import { Outlet } from 'react-router-dom'
import { LoginScreen } from '../features/auth/LoginScreen'
import { useAuth } from '../features/auth/useAuth'

/**
 * Renders the login screen in place of any protected route, without
 * redirecting. The URL is kept, so after login the student lands where they
 * were going — including a push deep link that arrived while logged out.
 */
export function RequireAuth() {
  const { auth, loading } = useAuth()

  if (loading) return <p className="centered">Načítám…</p>
  if (!auth) return <LoginScreen />

  return <Outlet />
}
